export enum DbMarkerStatus {
  Bypassed = "Bypassed",
  FalsePositive = "FalsePositive",
  TobeFixed = "TobeFixed",
  Fixed = "Fixed",
}
